import React from 'react'

import PortalModal from './PortalModal'

import Backend from "../../utils/Backend"
import Notify from "../../utils/Notify";
import General from '../../utils/General';

const CONTAINER_ID = "boi-payment-form"
export default class BoipaModal extends React.Component {
  constructor(props){
    super(props)

    this.state = {
      show: false,
      token: null,
      layout: props.modalClassName
    }
  }

  componentDidMount(){

  }

  _setupPaymentForm(token, paymentMethod, currencyCode){
    this.setState({ show: true })
    return new Promise((resolve, reject) => {
      let cashier = window.com.myriadpayments.api.cashier();
      cashier.init({
        baseUrl: paymentMethod.form_url,
        changeCallback : (event, data) => {
          if (data.height) {
            document.getElementById(CONTAINER_ID).height(data.height);
          }
        },
        successCallback : (event, data) => {
          console.log("Success:", event, data)
          this._handleCallback(data)
        },
        failureCallback : (event, data) => {
          console.log("Failure:", event, data)
          this._handleCallback(data)
        },
        cancelCallback : (event, data) => {
          console.log("Cancel:", event, data)
          this._handleCallback(data)
        }
      });

      let merchantIds = paymentMethod.merchant_ids
      let merchantId = merchantIds.default

      if(merchantIds[currencyCode]){
        merchantId = merchantIds[currencyCode]
      }

      console.log("**********")
      console.log("SETUP")
      console.log("**********")
      cashier.show({
        containerId: CONTAINER_ID,
        merchantId: merchantId,
        integrationMode: "iframe",
        token: token,
      });
      console.log("**********")
      console.log("INITIALIZED")
      console.log("**********")
    })
  }

  _handleCallback(data){

    let url = new URL(window.location.href);
    let params = new URLSearchParams(url.search);

    url = this.props.subscriptionPayment ? window.location.href : url

    params.set("txId", data.txId)
    params.set("amount", data.amount)
    params.set("result", data.result)
    params.set("currency", data.currency)
    params.set("merchantTxId", data.merchantTxId)

    General.setLocationHref(`${url}?${params.toString()}`)
  }

  render() {
    let {
      show
    } = this.state

    let className = `boi-card-modal ${this.props.modalClassName} `

    return (

      <PortalModal
        show={show}
        onHide={() => this.props.onClose()}
        showAsSideMenu="false"
        modalClasses={className}
      >

        <div className="boi-card">

            <div className="modal-head">
              <h2 className="mb-0">Enter Card Details</h2>
              <div class="modal-close modal-close-cross"></div>
            </div>

            <div className="modal-body">
              <div id={CONTAINER_ID}/>
            </div>

        </div>

      </PortalModal>

    )
  }
}

BoipaModal.defaultProps = {
  //modalClassName: 'sub-modal',
}
